import script from "./after-submit.vue?vue&type=script&lang=ts&setup=true"
export * from "./after-submit.vue?vue&type=script&lang=ts&setup=true"

import "./after-submit.vue?vue&type=style&index=0&id=d42c5f04&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d42c5f04"]])

export default __exports__